import { useQuery } from "react-query";
import { notification, Typography } from "antd";
import log from "../../utils/log";
import useAuthStore from "../../states/useAuth";
import useDB from "../useDB";

const { Title, Text } = Typography;

const useShopQuery = (url, params = {}, options = {}) => {
  const { user } = useAuthStore();
  const { get } = useDB();

  // Ensure params are defined
  if (!url || !params || Object.keys(params).length === 0) {
    throw new Error("URL & Params are required for useShopQuery.");
  }

  // Default query options
  const defaultOptions = {
    enabled: !!params, // Only enable the query if params are defined
    staleTime: 10000, // Default stale time of 10 seconds
    onError: (error) => {
      log.debug(error);
      notification.error({
        message: (
          <Title style={{ margin: 0 }} level={4}>
            Error
          </Title>
        ),
        description: <Text strong>Please refresh this page</Text>,
      });
    },
  };

  // Merge default options with user-provided options
  const queryOptions = { ...defaultOptions, ...options };

  // Define the query function
  const fetchShopData = async () => {
    const result = await get(url, params);
    return result;
  };

  // Use React Query's useQuery
  return useQuery(["shops", params], fetchShopData, queryOptions);
};

export default useShopQuery;
